import { render, staticRenderFns } from "./HeaderIndex.vue?vue&type=template&id=00bd4186"
import script from "./HeaderIndex.vue?vue&type=script&lang=js"
export * from "./HeaderIndex.vue?vue&type=script&lang=js"
import style0 from "./HeaderIndex.vue?vue&type=style&index=0&id=00bd4186&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports